import { createContext } from 'react';
import { ReviewCheckToggleContextType } from '#baseMenu/components/controls/middle-button/review-check-toggle';

const ReviewCheckToggleContext = createContext<ReviewCheckToggleContextType>(null);

export { ReviewCheckToggleContext };
